<template>
    <div class="personal_center">
        <div class="warp1200 fix">
            <PersonalCenterMenu :activeIndex="8" />
            <div class="f-fr center_right">
                <edit-user-info :isMaskValue="$store.state.page.isMaskValue"></edit-user-info>
            </div>
        </div>
    </div>
</template>

<script>
    // import api from '@/api'
    import PersonalCenterMenu from '@/components/User/PersonalCenterMenu'
    import EditUserInfo from '@/components/User/EditUserInfo'

    export default {
        name: 'EditInfo',
        components: {
            PersonalCenterMenu,
            EditUserInfo,
        },
        data () {
            return {}
        },
        beforeMount () {
            this.init()
        },
        methods: {
            async init () {
                await this.pageInit()
            },
            async pageInit () {
              const userToken = this.$store.state.user.userToken
                if (!userToken) {
                    this.$router.push(`/Orchard.Rccl.Users/Login/Login?returnUrl=${encodeURIComponent(window.location.pathname)}`)
                    return false
                }
            },
        },
    }
</script>

<style lang="less" scoped>
    .personal_center {
        background-color: #f5f5f5;
        .center_right{
            width: 945px;
            height: 827px;
            margin-top: 20px;
            background-color: #fff;
        }
    }
</style>
